import type { HotelBoxData } from '@/interfaces/components/hotelBoxData';
import type { TravelType } from '@/interfaces/common';
import AnalyticsEvent from './AnalyticsEvent';
import type GaItemList from './GaItemList';

export default class NearbyHotelsAnalytics extends AnalyticsEvent {
	static readonly VIEW_ITEM_LIST = 'view_item_list';

	static readonly ITEM_LIST_ID = 'hotels_nearby';

	static readonly ITEM_LIST_NAME = 'Hotels in der Nähe';

	static readonly SELECT_ITEM = 'select_item';

	fireViewItemList(): void {
		super.fireGoogleAnalyticsEventOrAddListener(NearbyHotelsAnalytics.VIEW_ITEM_LIST);
	}

	fireSelectItem(): void {
		super.fireGoogleAnalyticsEventOrAddListener(NearbyHotelsAnalytics.SELECT_ITEM);
	}

	static itemsMapping(
		hotel: HotelBoxData,
		travelType: TravelType,
		index: number
	) {
		return {
			item_id: hotel.HotelIffCode.toString(),
			item_name: hotel.Name,
			index,
			item_brand: hotel?.TourOperator?.TourOperatorCode,
			item_category: hotel?.Location?.Country.CountryName,
			item_category2: hotel?.Location?.Region.RegionName,
			item_category3: hotel?.Location?.City.CityName,
			item_variant: travelType,
			price: hotel?.Price,
			quantity: 1
		};
	}

	static fromNearbyOffersLoaded(
		hotels: HotelBoxData[],
		travelType: TravelType,
	): NearbyHotelsAnalytics {
		const items = hotels.map((hotel, index) => NearbyHotelsAnalytics.itemsMapping(hotel, travelType, index));
		const itemsList: GaItemList = {
			item_list_id: NearbyHotelsAnalytics.ITEM_LIST_ID,
			item_list_name: NearbyHotelsAnalytics.ITEM_LIST_NAME,
			items
		};
		return new NearbyHotelsAnalytics(itemsList);
	}

	static fromHotelOfferClicked(
		hotel: HotelBoxData,
		travelType: TravelType,
		index: number
	): NearbyHotelsAnalytics | undefined {
		const items = NearbyHotelsAnalytics.itemsMapping(hotel, travelType, index);
		const itemsList: GaItemList = {
			item_list_id: NearbyHotelsAnalytics.ITEM_LIST_ID,
			item_list_name: NearbyHotelsAnalytics.ITEM_LIST_NAME,
			items: [items],
		};
		return new NearbyHotelsAnalytics(itemsList);
	}
}
